import React from "react";
import { Row, Col, Form, Button, Card } from "react-bootstrap";
import Select, { components } from "react-select";

// 🔘 Custom option with checkbox
const Option = (props) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      checked={props.isSelected}
      readOnly
      style={{ marginRight: 8 }}
    />
    {props.label}
  </components.Option>
);

const TableFilters = ({ filtersConfig = [], filters, setFilters }) => {
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 38,
      borderColor: "#ced4da",
      boxShadow: "none",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#e0f7fa",
      borderRadius: 4,
      padding: "2px 4px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#00796b",
      fontWeight: 500,
    }),
    option: (base, { isSelected }) => ({
      ...base,
      backgroundColor: isSelected ? "#d4edda" : "white",
      "&:hover": { backgroundColor: "#f1f1f1" },
    }),
  };

  // 🔄 Reset all filters
  const clearAll = () => {
    setFilters({});
  };

  // 🛠️ Handle changes by type
  const handleChange = (f, val) => {
    if (f.type === "multiselect") {
      setFilters({
        ...filters,
        [f.key]: val?.map((s) => ({ value: s.value, label: s.label })) || [],
      });
    } else if (f.type === "select") {
      const opt = f.options.find((o) => o.value === val);
      setFilters({
        ...filters,
        [f.key]: opt ? { value: opt.value, label: opt.label } : null,
      });
    } else {
      setFilters({
        ...filters,
        [f.key]: val ? { value: val, label: val } : null,
      });
    }
  };
  const renderField = (f) => {
    const current = filters[f.key];

    switch (f.type) {
      case "date":
        return (
          <Form.Control
            type="date"
            value={current?.value || ""}
            onChange={(e) => handleChange(f, e.target.value)}
          />
        );

      case "text":
        return (
          <div className="d-flex align-items-center">
            <Form.Control
              type="text"
              value={current?.value || ""}
              placeholder={f.label}
              onChange={(e) => handleChange(f, e.target.value)}
            />
          </div>
        );

      case "select":
        return (
          <div className="d-flex align-items-center">
            <Form.Select
              value={current?.value || ""}
              onChange={(e) => handleChange(f, e.target.value)}
            >
              <option value="">All {f.label}</option>
              {f.options?.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Form.Select>
            
          </div>
        );

      case "multiselect":
        return (
          <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{ Option }}
            options={f.options}
            value={current || []}
            onChange={(val) => handleChange(f, val)}
            placeholder={`Select ${f.label}`}
            styles={customStyles}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Card className="mb-3 border shadow-sm">
      <Card.Header className="d-flex justify-content-between align-items-center bg-light">
        <span className="fw-bold text-light">Filters</span>
        <Button variant="outline-light" size="sm" onClick={clearAll}>
          Clear All
        </Button>
      </Card.Header>
      <Card.Body>
        <Row className="g-3">
          {filtersConfig.map((f) => (
            <Col key={f.key} xs={12} md={3}>
              <Form.Group controlId={f.key}>
                <Form.Label>{f.label}</Form.Label>
                {renderField(f)}
              </Form.Group>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TableFilters;
